/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CircularProgress,
  Divider,
  Grid,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import withWidth from '@material-ui/core/withWidth';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import FacebookIcon from '@material-ui/icons/Facebook';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import HorizontalDiagramContainer from '@orientaction/components/Beneficiary/Result/Horizontal';
import PieDiagramContainer from '@orientaction/components/Beneficiary/Result/Pie';
import RadarDiagram from '@orientaction/components/Beneficiary/Result/Radar';
import SimplePie from '@orientaction/components/Beneficiary/Result/SimplePie';
import YoutubeIframe from '@orientaction/components/VideoYoutubeEmbed';
import { LayoutResultat } from '@orientaction/layouts';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { find, kebabCase } from 'lodash';
import ouibounce from 'ouibounce';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'react-simple-snackbar';
import FeedbackModal from '../../components/FeedbackModal';
import IASynthesisBlock from '../../components/IASynthesisBlock';
import RecommendedTestsSection from '../../components/RecommendedTestsSection';
import useFeedbackSubmit from '../../hooks/useFeedbackSubmit';
import useResponseUser from '../../hooks/useResponseUser';
import HelpModal from '../Authentication/Commons/HelpModal';
import { getFromLS } from '../../utils/utils';
import { useStyles } from './style';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { Layout } from '@orientaction/components/Layout';

Chart.register(ChartDataLabels);

const TEXT_MAX_LENGTH = 400;

// Fonction utilitaire pour nettoyer les styles de couleur inline
function removeInlineColorStyles(html: string): string {
  if (!html) return html;
  return html.replace(/style="[^"]*color:[^;"']*;? ?[^"]*"/gi, '');
}

const Resultats = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [openSnackbar] = useSnackbar({
    position: isMobile ? 'top-center' : 'bottom-right',
    style: {
      position: 'fixed',
      backgroundColor: '#0E1247',
      color: '#FFFFFF',
      fontFamily: 'Poppins, sans-serif',
      fontSize: '16px',
      fontWeight: 400,
      borderRadius: '8px',
      padding: '8px 8px',
      minWidth: '400px',
      minHeight: '48px',
      boxShadow: '0px 4px 12px rgba(14, 18, 71, 0.3)',
      display: 'flex',
      alignItems: 'center',
      ...(isMobile
        ? {
            top: '24px',
            left: '50%',
            transform: 'translateX(-50%)',
            right: 'auto',
            bottom: 'auto',
          }
        : {
            bottom: '24px',
            right: '24px',
            left: 'auto',
            top: 'auto',
            transform: 'none',
          }),
      margin: 0,
    },
  });
  const [test, setTest] = useState<any>();
  const [variables, setVariables] = useState([]);
  const [userResponse, setUserResponse] = useState<any>(undefined);
  const [completedTestIds, setCompletedTestIds] = useState<number[]>([]);
  const { getResponseTestUser, getTestVariables, getResponseUsers } = useResponseUser();
  const user = JSON.parse(getFromLS('userInfos') || '{}');
  const dataParams: any = useParams();
  const [loadPage, setLoadPage] = useState(true);
  const [isTextExpanded, setIsTextExpanded] = useState(false);
  const [isTextOverflowing, setIsTextOverflowing] = useState(false);
  const textContentRef = useRef<HTMLDivElement>(null);
  const [helpOpen, setHelpOpen] = useState(false);

  // États pour la modal de feedback
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const hasTriggeredRef = useRef(false);
  const [aglomerationsTraited, setAglomerationsTraited] = useState([]);
  const [dataMax, setDataMax] = useState<any>(null);
  const [videoReady, setVideoReady] = useState(false);

  // Hook pour gérer la soumission des feedbacks
  const { submitFeedback, isSubmitting, error } = useFeedbackSubmit(
    test?.id?.toString() || ''
  );

  useEffect(() => {
    (async () => {
      if (dataParams.id) {
        setLoadPage(true);
        const oneResponseTest = await getResponseTestUser(dataParams.id);
        const variableResponse = await getTestVariables(oneResponseTest.attributes.test.data.id);

        if (oneResponseTest.attributes.test.data.attributes.diagram.data.id === 6) {
          const groupedArrayAglo = Object.values(
            oneResponseTest?.attributes?.responses?.data?.reduce((acc: any, response: any) => {
              const aglo = response.attributes.question.data.attributes.aglomeration.data;
              const agloId = aglo.id;
              const agloName = aglo.attributes.name;
              const variableValue = response.attributes.variableValue || 0;

              if (!acc[agloId]) {
                acc[agloId] = {
                  agloId,
                  agloName,
                  responses: [],
                  totalVariableValue: 0,
                };
              }

              acc[agloId].responses.push(response);
              acc[agloId].totalVariableValue += variableValue;

              return acc;
            }, {})
          );

          const variablesToConcat =
            oneResponseTest?.attributes?.test?.data?.attributes?.aglomerations?.data?.map(
              (aglo: any) => {
                const grouped: any = groupedArrayAglo.find((g: any) => g.agloId === aglo.id);

                if (!grouped) {
                  return {
                    ...aglo,
                    matchedVariable: null,
                  };
                }

                const matchedVariable = aglo?.attributes?.variables?.data?.find(
                  (v: any) =>
                    grouped?.totalVariableValue >= v?.attributes?.minInterval &&
                    grouped?.totalVariableValue <= v?.attributes?.maxInterval
                );

                return {
                  ...aglo,
                  totalVariableValue: grouped.totalVariableValue,
                  matchedVariable: matchedVariable || null,
                };
              }
            );
          setAglomerationsTraited(
            variablesToConcat.sort((a: any, b: any) => b.totalVariableValue - a.totalVariableValue)
          );
        } else {
          setVariables(variableResponse.data);
          setVariables(variableResponse.data);
          setUserResponse(oneResponseTest);
        }
        setTest(oneResponseTest.attributes.test.data);

        // Debug: vérifier les IDs

        // Récupérer tous les tests déjà passés par l'utilisateur pour marquer ceux qui sont "Test fait"
        try {
          const userAllResponses = await getResponseUsers(user.id);

          // Extraire les IDs des tests déjà passés
          const completedIds = userAllResponses
            .map((response: any) => response?.attributes?.test?.data?.id)
            .filter((id: number) => id !== undefined && id !== null);

          // Supprimer les doublons
          const uniqueCompletedIds = Array.from(new Set(completedIds)) as number[];
          setCompletedTestIds(uniqueCompletedIds);
        } catch (fetchError) {
          console.error('Erreur lors de la récupération des tests déjà passés:', fetchError);
          setCompletedTestIds([]);
        }

        // Vérifier si l'utilisateur a déjà donné son avis sur ce test
        // Suppression de la vérification d'avis existant - les utilisateurs peuvent maintenant donner plusieurs avis

        setLoadPage(false);
      }
    })();
  }, []);

  // Logique de déclenchement de la modal de feedback
  useEffect(() => {
    if (loadPage || hasTriggeredRef.current) {
      return;
    }

    // Timer de 20 secondes
    const timer = setTimeout(() => {
      if (!hasTriggeredRef.current) {
        setShowFeedbackModal(true);
        hasTriggeredRef.current = true;
      }
    }, 90000);

    // Ouibounce uniquement sur desktop
    let ouibounceInstance: any = null;
    if (!isMobile) {
      ouibounceInstance = ouibounce(false, {
        callback: () => {
          if (!hasTriggeredRef.current) {
            setShowFeedbackModal(true);
            hasTriggeredRef.current = true;
            clearTimeout(timer);
          }
        },
        aggressive: true,
        sensitivity: 50,
        delay: 500,
        sitewide: true,
      });
    }

    return () => {
      clearTimeout(timer);
      if (ouibounceInstance && ouibounceInstance.disable) {
        ouibounceInstance.disable();
      }
    };
  }, [loadPage, isMobile]);

  // Gestion de la fermeture et soumission de la modal
  const handleFeedbackClose = () => {
    setShowFeedbackModal(false);
  };

  const handleFeedbackSubmit = async (rating: number, comment: string) => {
    const success = await submitFeedback(rating, comment);
    if (success) {
      setShowFeedbackModal(false);
      openSnackbar(
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
            <circle cx="18" cy="18" r="18" fill="#23296F" />
            <path
              d="M24 14L16 22L12 18"
              stroke="#FFFFFF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Votre avis a bien été pris en compte</span>
        </div>
      );
    }
  };

  const classes = useStyles();
  const isSimplePie = test?.attributes?.diagram?.data?.id === 1;

  // Récupération des infos pour l'affichage
  const titrePage = test?.attributes?.resultTitle || test?.attributes?.title || '';

  const titreGraphique = test?.attributes?.diagramTitle || '';
  const imageUrl =
    test?.attributes?.resultImage?.url ||
    test?.attributes?.image?.url ||
    test?.attributes?.image ||
    '';
  const texteResultat =
    dataMax?.description ||
    (userResponse as any)?.attributes?.responses?.data?.[0]?.attributes?.variable?.data?.[0]
      ?.attributes?.description ||
    '';

  // Effet pour détecter si le texte dépasse 336px
  useEffect(() => {
    const checkTextHeight = () => {
      if (!textContentRef.current || !texteResultat || isTextExpanded) return;

      const element = textContentRef.current;

      // S'assurer que l'élément est visible et a du contenu
      const rect = element.getBoundingClientRect();
      if (rect.height === 0) {
        // Réessayer si l'élément n'est pas encore rendu
        setTimeout(checkTextHeight, 50);
        return;
      }

      // Temporairement retirer les contraintes de hauteur pour mesurer la hauteur naturelle
      const originalMaxHeight = element.style.maxHeight;
      const originalOverflow = element.style.overflow;

      element.style.maxHeight = 'none';
      element.style.overflow = 'visible';

      // Forcer un reflow pour s'assurer que les changements sont appliqués
      element.offsetHeight;

      const naturalHeight = element.scrollHeight;

      // Restaurer les styles originaux
      element.style.maxHeight = originalMaxHeight;
      element.style.overflow = originalOverflow;

      // Vérifier si ça dépasse 336px
      setIsTextOverflowing(naturalHeight > 336);
    };

    if (texteResultat && !loadPage) {
      // Attendre que le composant soit complètement chargé
      setTimeout(checkTextHeight, 100);
    }
  }, [texteResultat, isTextExpanded, loadPage]);

  const sendDataMax = useCallback((data: any) => {
    setDataMax(data);
  }, []);

  // Calcul des données pour les tests de type "seuils et intervalles" (type 4)
  useEffect(() => {
    if (test?.attributes?.diagram?.data?.id === 4 && userResponse && variables) {
      // Calculer le score total
      const sumScore =
        (userResponse?.attributes?.responses?.data as any[])?.reduce(
          (accumulator: number, resp: any) => {
            return accumulator + (resp?.attributes?.variableValue || 0);
          },
          0
        ) || 0;

      // Trouver la variable correspondant au score
      const variableToShow = find(variables, (variable: any) => {
        return (
          variable?.attributes?.minInterval <= sumScore &&
          sumScore <= variable?.attributes?.maxInterval
        );
      });

      if (variableToShow) {
        sendDataMax({
          title: variableToShow.attributes.title,
          image: variableToShow.attributes.image,
          video: variableToShow.attributes.video,
          description: variableToShow.attributes.description,
          label: variableToShow.attributes.name,
        });
      }
    }
  }, [test, userResponse, variables, sendDataMax]);

  // Force video render when dataMax is ready
  useEffect(() => {
    if (dataMax?.video) {
      // Petit délai pour assurer la stabilité du render
      setTimeout(() => setVideoReady(true), 100);
    }
  }, [dataMax]);

  // Gestion du diagramme
  const diagramme = useMemo(() => {
    if (userResponse && isSimplePie) {
      return (
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <SimplePie
            userResponse={userResponse}
            showMainTitle={false}
            showRestitutionTitle={false}
            showRestitutionText={false}
            sendDataMax={sendDataMax}
          />
        </div>
      );
    }
    if (userResponse && test?.attributes?.diagram?.data?.id === 2) {
      return (
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
          }}>
          <PieDiagramContainer
            userResponse={userResponse}
            newVersion={true}
            sendDataMax={sendDataMax}
          />
        </div>
      );
    }
    if (userResponse && [3, 5].includes(test?.attributes?.diagram?.data?.id)) {
      return (
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <HorizontalDiagramContainer
            variables={variables}
            userResponse={userResponse}
            typeTest={test?.attributes?.diagram?.data?.id}
            newVersion={true}
            sendDataMax={sendDataMax}
          />
        </div>
      );
    }
    if (userResponse && test?.attributes?.diagram?.data?.id === 4) {
      // Pour les tests de type "seuils et intervalles", on récupère les données de restitution sans rendre le diagramme
      // Le calcul et l'envoi des données se fait via un useEffect séparé
      return null;
    }
    return null;
  }, [userResponse, test, variables, isSimplePie, sendDataMax]);

  const [expandedIds, setExpandedIds] = useState<any>([]);

  const handleChange = (id: any) => (event: any, isExpanded: boolean) => {
    setExpandedIds((prev: any) =>
      isExpanded ? (prev.includes(id) ? prev : [...prev, id]) : prev.filter((x: any) => x !== id)
    );
  };

  const isActive = (id: any) => expandedIds.includes(id);

  const testUrl = `${process.env.REACT_APP_SHARE_ENDPOINT}/api/test/${test?.id}/${kebabCase(
    test?.attributes?.title
  )}`;

  const besoinAideRow = (
    <div
      className={classes.besoinAideRow}
      onClick={() => setHelpOpen(true)}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setHelpOpen(true);
        }
      }}
      role="button"
      tabIndex={0}>
      <div className={classes.besoinAideLabels}>
        <Typography component="span" className={classes.besoinAideTitle}>
          Besoin d&apos;aide ?
        </Typography>
        <Typography component="span" className={classes.besoinAideContact}>
          Contactez-nous
        </Typography>
      </div>
      <ArrowForwardIcon className={classes.besoinAideIcon} />
    </div>
  );

  const componentShare = (
    <div className={classes.shareContainerCustom} style={isSimplePie ? { marginTop: 0 } : {}}>
      <div className={classes.shareBorderTop} />
      <div className={classes.shareBlock}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 40,
            width: '100%',
          }}>
          <span className={classes.shareTitle}>Partager ce test</span>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 12,
            }}>
            <TwitterShareButton url={testUrl} title={dataMax?.title}>
              <TwitterIcon
                style={{
                  color: '#001A8C',
                  fontSize: 16,
                  height: 16,
                  width: 16,
                  margin: 0,
                  display: 'block',
                  cursor: 'pointer',
                }}
              />
            </TwitterShareButton>

            <FacebookShareButton url={testUrl} title={dataMax?.title}>
              <FacebookIcon
                style={{
                  color: '#001A8C',
                  fontSize: 16,
                  height: 16,
                  width: 16,
                  margin: 0,
                  display: 'block',
                  cursor: 'pointer',
                }}
              />
            </FacebookShareButton>

            <LinkedinShareButton url={testUrl} title={dataMax?.title}>
              <LinkedInIcon
                style={{
                  color: '#001A8C',
                  fontSize: 16,
                  height: 16,
                  width: 16,
                  margin: 0,
                  display: 'block',
                  cursor: 'pointer',
                }}
              />
            </LinkedinShareButton>
            <Button
              variant="contained"
              style={{
                background: '#001A8C',
                color: '#fff',
                borderRadius: 20,
                marginLeft: 0,
                padding: '0 18px',
                fontWeight: 500,
                fontSize: 12,
                textTransform: 'none',
                boxShadow: 'none',
                display: 'flex',
                alignItems: 'center',
                height: 25,
                minWidth: 0,
              }}
              className={classes.copyLinkButton}
              endIcon={
                <FileCopyOutlinedIcon
                  style={{
                    color: '#fff',
                    fontSize: 16,
                    height: 16,
                    width: 16,
                    marginLeft: 4,
                  }}
                />
              }
              onClick={() => {
                navigator.clipboard.writeText(testUrl);
              }}>
              Copier le lien
            </Button>
          </div>
        </div>
      </div>
      {besoinAideRow}
    </div>
  );

  return (
    <Layout isV2={true}>
      {loadPage ? (
        <div className={classes.bodycenter}>
          <CircularProgress style={{ color: '#000A8C' }} />
        </div>
      ) : (
        <div className={classes.desktopContainer}>
          {/* MOBILE: Header centré en haut */}
          {isMobile && dataMax && (
            <div className={classes.mobileHeaderContainer}>
              <Typography style={{ color: '#5763FF', fontWeight: 700, fontSize: 14 }}>
                Résultat du test
              </Typography>
              <Typography
                lang="fr"
                className={classes.titleMax}
                dangerouslySetInnerHTML={{
                  __html: dataMax?.title || titrePage,
                }}
              />
            </div>
          )}

          {/* Deux colonnes */}
          {test?.attributes?.diagram?.data?.id !== 6 &&
            (!dataMax ? (
              <div style={{ marginTop: isMobile ? '50%' : '13%', marginBottom: 16, marginLeft: 16, marginRight: 16 }}>
                <Typography
                  style={{
                    color: '#0E1247',
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: 1.6,
                  }}>
                  Vos résultats de test ne peuvent pas s'afficher correctement. Nous vous invitons à
                  revenir vers nous.
                </Typography>
                <span style={{ display: 'none' }}>{diagramme}</span>
              </div>
            ) : (
              <div className={classes.mainContentRow}>
                {/* Colonne gauche : titres + image + partage */}
                <div className={classes.leftColImage}>
                  <div className={classes.headerResultatTest}>
                    <Typography style={{ color: '#5763FF', fontWeight: 700, fontSize: 14 }}>
                      Résultat du test
                    </Typography>
                    <Typography
                      lang="fr"
                      className={classes.titleMax}
                      dangerouslySetInnerHTML={{
                        __html: dataMax?.title || titrePage,
                      }}
                    />
                  </div>
                  {/* Image de la restitution */}
                  {dataMax?.image && test?.attributes?.diagram?.data?.id !== 1 && (
                    <img
                      src={dataMax.image}
                      alt="illustration résultat"
                      className={classes.resultImage}
                    />
                  )}

                  {/* Vidéo de la restitution */}
                  {dataMax?.video && videoReady && (
                    <div
                      style={{
                        width: '100%',
                        minHeight: '200px',
                        position: 'relative',
                        marginBottom: '20px',
                      }}>
                      <YoutubeIframe key={dataMax.video} url={dataMax.video} />
                    </div>
                  )}

                  {/* Bloc partage déplacé ici */}
                  {componentShare}
                </div>
                {/* Colonne droite : graphique + texte */}
                <div className={classes.rightColContent}>
                  {/* MOBILE: Divider après le titre principal */}
                  {isMobile && (
                    <Divider
                      style={{
                        width: 'calc(100% - 32px)',
                        marginLeft: 16,
                        marginRight: 16,
                        marginBottom: 24,
                        backgroundColor: '#E0E0E0',
                      }}
                    />
                  )}

                  {/* Titre du graphique */}
                  {titreGraphique && !isSimplePie && (
                    <Typography className={classes.diagramTitle}>{titreGraphique}</Typography>
                  )}
                  {/* DESKTOP: Diagramme */}
                  {!isMobile && diagramme}
                  {/* DESKTOP: Bloc texte résultat */}
                  {!isMobile &&
                    texteResultat &&
                    (() => {
                      const cleanText = removeInlineColorStyles(texteResultat);
                      const shouldShowButton = isTextOverflowing && !isTextExpanded;

                      return (
                        <div style={{ position: 'relative', width: '100%', marginTop: 20 }}>
                          <div
                            ref={textContentRef}
                            className={classes.resultTextBlock}
                            style={{
                              color: '#0E1247',
                              minHeight: 'auto',
                              maxHeight: isTextOverflowing && !isTextExpanded ? 336 : 'none',
                              overflow: isTextOverflowing && !isTextExpanded ? 'hidden' : 'visible',
                              position: 'relative',
                              width: '100%',
                              maxWidth: '100%',
                              boxSizing: 'border-box',
                              marginTop: isSimplePie ? 40 : 0,
                            }}>
                            <Typography
                              className={classes.resultText}
                              style={{
                                color: '#0E1247',
                                fontSize: 16,
                                fontWeight: 400,
                                lineHeight: 1.6,
                                marginBottom: shouldShowButton ? 0 : 16,
                              }}>
                              {ReactHtmlParser(cleanText)}
                            </Typography>

                            {/* Bouton "Voir moins" - Mode ouvert, DANS le bloc */}
                            {isTextOverflowing && isTextExpanded && (
                              <div style={{ textAlign: 'center', marginTop: 16 }}>
                                <Button
                                  variant="text"
                                  onClick={() => setIsTextExpanded(false)}
                                  style={{
                                    color: '#001858',
                                    textDecoration: 'underline',
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    background: 'transparent',
                                    boxShadow: 'none',
                                    padding: '8px 0',
                                  }}>
                                  Voir moins
                                </Button>
                              </div>
                            )}

                            {/* Effet de fondu quand le texte est tronqué */}
                            {isTextOverflowing && !isTextExpanded && (
                              <div
                                style={{
                                  position: 'absolute',
                                  bottom: 0,
                                  left: 0,
                                  right: 0,
                                  height: 100,
                                  background:
                                    'linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.95), #fff)',
                                  pointerEvents: 'none',
                                }}
                              />
                            )}
                          </div>

                          {/* Bouton "Voir plus" - SORTI du div avec overflow */}
                          {shouldShowButton && (
                            <Button
                              className={classes.showMoreBtnAbsolute}
                              variant="outlined"
                              onClick={() => setIsTextExpanded(true)}>
                              Afficher le reste de mes résultats
                              <img
                                src="/icons/icon-text-plus.svg"
                                alt=""
                                style={{
                                  width: 16,
                                  height: 16,
                                  marginLeft: 8,
                                  marginBottom: '0.2rem',
                                }}
                              />
                            </Button>
                          )}
                        </div>
                      );
                    })()}
                  {/* Bouton faire un nouveau test */}
                </div>
              </div>
            ))}

          {/* MOBILE: Diagramme en pleine largeur */}
          {isMobile && test?.attributes?.diagram?.data?.id !== 6 && dataMax && (
            <div
              style={{
                width: 'calc(100% - 32px)',
                marginLeft: 16,
                marginRight: 16,
                marginTop: 16,
              }}>
              {diagramme}
            </div>
          )}

          {/* MOBILE: Bloc texte résultat après le diagramme */}
          {isMobile && test?.attributes?.diagram?.data?.id !== 6 && texteResultat && dataMax && (
            <div
              style={{
                marginLeft: 16,
                marginRight: 16,
                width: 'calc(100% - 32px)',
                marginTop: 20,
              }}>
              {(() => {
                const cleanText = removeInlineColorStyles(texteResultat);
                const shouldShowButton = isTextOverflowing && !isTextExpanded;

                return (
                  <div style={{ position: 'relative' }}>
                    <div
                      ref={textContentRef}
                      className={classes.resultTextBlock}
                      style={{
                        color: '#0E1247',
                        minHeight: 'auto',
                        maxHeight: isTextOverflowing && !isTextExpanded ? 336 : 'none',
                        overflow: isTextOverflowing && !isTextExpanded ? 'hidden' : 'visible',
                        position: 'relative',
                      }}>
                      <Typography
                        className={classes.resultText}
                        style={{
                          color: '#0E1247',
                          fontSize: 16,
                          fontWeight: 400,
                          lineHeight: 1.6,
                          marginBottom: shouldShowButton ? 0 : 16,
                        }}>
                        {ReactHtmlParser(cleanText)}
                      </Typography>

                      {/* Bouton "Voir moins" - Mode ouvert, DANS le bloc */}
                      {isTextOverflowing && isTextExpanded && (
                        <div style={{ textAlign: 'center', marginTop: 16 }}>
                          <Button
                            variant="text"
                            onClick={() => setIsTextExpanded(false)}
                            style={{
                              color: '#001858',
                              textDecoration: 'underline',
                              textTransform: 'none',
                              fontWeight: 600,
                              background: 'transparent',
                              boxShadow: 'none',
                              padding: '8px 0',
                            }}>
                            Voir moins
                          </Button>
                        </div>
                      )}

                      {/* Effet de fondu quand le texte est tronqué */}
                      {isTextOverflowing && !isTextExpanded && (
                        <div
                          style={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: 100,
                            background:
                              'linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.95), #fff)',
                            pointerEvents: 'none',
                          }}
                        />
                      )}
                    </div>

                    {/* Bouton "Voir plus" - SORTI du div avec overflow */}
                    {shouldShowButton && (
                      <Button
                        className={classes.showMoreBtnAbsolute}
                        variant="outlined"
                        onClick={() => setIsTextExpanded(true)}>
                        Afficher le reste de mes résultats
                        <img
                          src="/icons/icon-text-plus.svg"
                          alt=""
                          style={{
                            width: 16,
                            height: 16,
                            marginLeft: 8,
                            marginBottom: '0.2rem',
                          }}
                        />
                      </Button>
                    )}
                  </div>
                );
              })()}
            </div>
          )}

          {/* MOBILE: Section de partage centrée */}
          {isMobile && test?.attributes?.diagram?.data?.id !== 6 && dataMax && (
            <div className={classes.mobileShareContainer}>
              <Typography className={classes.mobileShareTitle}>Partager ce test</Typography>
              <div className={classes.mobileShareActions}>
                <TwitterShareButton url={testUrl} title={dataMax?.title}>
                  <TwitterIcon
                    style={{
                      color: '#001A8C',
                      fontSize: 16,
                      height: 16,
                      width: 16,
                      margin: 0,
                      display: 'block',
                      cursor: 'pointer',
                    }}
                  />
                </TwitterShareButton>

                <FacebookShareButton url={testUrl} title={dataMax?.title}>
                  <FacebookIcon
                    style={{
                      color: '#001A8C',
                      fontSize: 16,
                      height: 16,
                      width: 16,
                      margin: 0,
                      display: 'block',
                      cursor: 'pointer',
                    }}
                  />
                </FacebookShareButton>

                <LinkedinShareButton url={testUrl} title={dataMax?.title}>
                  <LinkedInIcon
                    style={{
                      color: '#001A8C',
                      fontSize: 16,
                      height: 16,
                      width: 16,
                      margin: 0,
                      display: 'block',
                      cursor: 'pointer',
                    }}
                  />
                </LinkedinShareButton>
                <Button
                  variant="contained"
                  style={{
                    background: '#001A8C',
                    color: '#fff',
                    borderRadius: 20,
                    marginLeft: 0,
                    padding: '0 18px',
                    fontWeight: 500,
                    fontSize: 12,
                    textTransform: 'none',
                    boxShadow: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    height: 25,
                    minWidth: 0,
                  }}
                  className={classes.copyLinkButton}
                  endIcon={
                    <FileCopyOutlinedIcon
                      style={{
                        color: '#fff',
                        fontSize: 16,
                        height: 16,
                        width: 16,
                        marginLeft: 4,
                      }}
                    />
                  }
                  onClick={() => {
                    navigator.clipboard.writeText(testUrl);
                  }}>
                  Copier le lien
                </Button>
              </div>
              {besoinAideRow}
            </div>
          )}

          {/* IA Synthesis Block */}
          {test?.attributes?.diagram?.data?.id !== 6 && userResponse && (
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                padding: isMobile ? '32px 16px' : '40px 0',
              }}>
              <IASynthesisBlock
                userId={user.id}
                responseTestId={dataParams.id}
                testName={test?.attributes?.title || 'Test'}
              />
            </div>
          )}

          {test?.attributes?.diagram?.data?.id === 6 && (
            <>
              <div className={classes.mainContentRow2}>
                {!isMobile && aglomerationsTraited && aglomerationsTraited.some((el: any) => el?.matchedVariable) && (
                  <>
                    <Typography style={{ color: '#5763FF', fontWeight: 700, fontSize: 18 }}>
                      Résultat du test
                    </Typography>
                    <Typography className={classes.textTitle}>{titrePage}</Typography>
                  </>
                )}
                <div className={classes.trait} />

                {aglomerationsTraited &&
                aglomerationsTraited.some((el: any) => !el?.matchedVariable) ? (
                  <div style={{ marginTop: 24, marginBottom: 16 }}>
                    <Typography
                      style={{
                        color: '#0E1247',
                        fontSize: 14,
                        fontWeight: 500,
                        lineHeight: 1.6,
                      }}>
                      Vos résultats de test ne peuvent pas s'afficher correctement. Nous vous
                      invitons à revenir vers nous.
                    </Typography>
                  </div>
                ) : (
                  <>
                    <Grid container={true} spacing={5}>
                      <Grid item={true} lg={5} xs={12} className={classes.containerText}>
                        <Typography className={classes.titleBlocks}>
                          Explorez les détails de vos résultats
                        </Typography>
                        <div className={classes.contentAglomeration}>
                          <Typography
                            style={{
                              color: '#151528',
                              fontWeight: 700,
                              fontSize: 14,
                              marginBottom: 13,
                            }}>
                            Vos scores
                          </Typography>
                          {aglomerationsTraited &&
                            aglomerationsTraited.map((agl: any, index: number) => (
                              <div key={agl.attributes?.name ?? index} className={classes.numberWithText}>
                                <div style={{ color: '#000A8C', width: 30 }}>
                                  {agl.totalVariableValue}{' '}
                                </div>
                                <div>{agl.attributes.name}</div>
                              </div>
                            ))}
                        </div>
                      </Grid>
                      <Grid item={true} lg={7} xs={12} className={classes.containerDiagram}>
                        <Typography className={classes.titleBlocks} style={{ textAlign: 'center' }}>
                          {titreGraphique || 'Titre du graphique'}
                        </Typography>
                        <RadarDiagram
                          data={aglomerationsTraited}
                          min={test?.attributes?.minValueAg}
                          max={test?.attributes?.maxValueAg}
                        />
                      </Grid>
                    </Grid>

                    <div style={{ marginTop: 10, marginBottom: 20 }}>
                      <Typography className={classes.titleBlocks}>
                        Explorez les détails de vos résultats par variable
                      </Typography>
                      <Typography className={classes.subtitleBlocks}>
                        Cliquez sur la variable pour découvrir vos résultats
                      </Typography>
                    </div>
                    <div className={classes.containerAccordion}>
                      {aglomerationsTraited &&
                        aglomerationsTraited.map((el: any) => (
                          <Accordion
                            key={el.id}
                            expanded={isActive(el.id)}
                            onChange={handleChange(el.id)}
                            style={{
                              marginTop: 5,
                              border: isActive(el.id) ? 'none' : '1px solid #000A8C',
                              overflow: 'hidden',
                            }}
                            elevation={0}>
                            <AccordionSummary
                              expandIcon={
                                <ExpandMoreIcon
                                  style={{ color: isActive(el.id) ? 'white' : 'black' }}
                                />
                              }
                              aria-controls="panel1a-content"
                              style={{
                                background: isActive(el.id) ? '#000A8C' : 'white',
                                padding: `5px ${isMobile ? 16 : 12}px`,
                              }}
                              id={el.id}>
                              <Typography
                                className={classes.heading}
                                style={{ color: isActive(el.id) ? 'white' : '' }}>
                                {el.attributes.name}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails style={{ paddingTop: 20, paddingBottom: 20 }}>
                              <Grid container={true} spacing={5}>
                                <Grid
                                  item={true}
                                  lg={6}
                                  xs={12}
                                  className={classes.noPaddingBottom}>
                                  <div className={classes.headerResultatTest}>
                                    <Typography
                                      style={{
                                        color: '#5763FF',
                                        fontWeight: 700,
                                        fontSize: 18,
                                        marginBottom: 4,
                                      }}>
                                      Résultat du test
                                    </Typography>
                                    <Typography
                                      className={classes.titleVariable}
                                      dangerouslySetInnerHTML={{
                                        __html: el?.matchedVariable?.attributes?.title,
                                      }}
                                    />
                                  </div>
                                  {el?.matchedVariable?.attributes?.typeMedia === 'image' && (
                                    <img
                                      src={el?.matchedVariable?.attributes?.image}
                                      alt="illustration résultat"
                                      className={classes.resultImage}
                                    />
                                  )}
                                  {el?.matchedVariable?.attributes?.typeMedia === 'video' && (
                                    <YoutubeIframe url={el?.matchedVariable?.attributes?.video} />
                                  )}
                                </Grid>
                                {/* Colonne droite : graphique + texte */}
                                <Grid
                                  item={true}
                                  lg={6}
                                  xs={12}
                                  style={isMobile ? { paddingTop: 10 } : {}}>
                                  {el?.matchedVariable?.attributes?.description &&
                                    (() => {
                                      const cleanText = removeInlineColorStyles(
                                        el?.matchedVariable?.attributes?.description
                                      );
                                      const shouldShowButton = isTextOverflowing && !isTextExpanded;

                                      return (
                                        <div style={{ position: 'relative' }}>
                                          <div
                                            ref={textContentRef}
                                            className={classes.resultTextBlock}
                                            style={{
                                              color: '#0E1247',
                                              minHeight: 'auto',
                                              maxHeight:
                                                isTextOverflowing && !isTextExpanded ? 336 : 'none',
                                              overflow:
                                                isTextOverflowing && !isTextExpanded
                                                  ? 'hidden'
                                                  : 'visible',
                                              position: 'relative',
                                              width: 'auto',
                                            }}>
                                            <Typography
                                              className={classes.resultText}
                                              style={{
                                                color: '#0E1247',
                                                fontSize: 16,
                                                fontWeight: 400,
                                                lineHeight: 1.6,
                                                marginBottom: shouldShowButton ? 0 : 16,
                                              }}>
                                              {ReactHtmlParser(cleanText)}
                                            </Typography>

                                            {/* Bouton "Voir moins" - Mode ouvert, DANS le bloc */}
                                            {isTextOverflowing && isTextExpanded && (
                                              <div style={{ textAlign: 'center', marginTop: 16 }}>
                                                <Button
                                                  variant="text"
                                                  onClick={() => setIsTextExpanded(false)}
                                                  style={{
                                                    color: '#001858',
                                                    textDecoration: 'underline',
                                                    textTransform: 'none',
                                                    fontWeight: 600,
                                                    background: 'transparent',
                                                    boxShadow: 'none',
                                                    padding: '8px 0',
                                                  }}>
                                                  Voir moins
                                                </Button>
                                              </div>
                                            )}

                                            {/* Effet de fondu quand le texte est tronqué */}
                                            {isTextOverflowing && !isTextExpanded && (
                                              <div
                                                style={{
                                                  position: 'absolute',
                                                  bottom: 0,
                                                  left: 0,
                                                  right: 0,
                                                  height: 40,
                                                  background: 'linear-gradient(transparent, #fff)',
                                                  pointerEvents: 'none',
                                                }}
                                              />
                                            )}
                                          </div>

                                          {/* Bouton "Voir plus" - SORTI du div avec overflow */}
                                          {shouldShowButton && (
                                            <Button
                                              className={classes.showMoreBtnAbsolute}
                                              variant="outlined"
                                              onClick={() => setIsTextExpanded(true)}>
                                              Afficher le reste de mes résultats
                                              <img
                                                src="/icons/icon-text-plus.svg"
                                                alt=""
                                                style={{
                                                  width: 16,
                                                  height: 16,
                                                  marginLeft: 8,
                                                  marginBottom: '0.2rem',
                                                }}
                                              />
                                            </Button>
                                          )}
                                        </div>
                                      );
                                    })()}
                                  {/* Bouton faire un nouveau test */}
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        ))}
                    </div>
                  </>
                )}
              </div>
              {!isMobile ? (
                componentShare
              ) : (
                <div className={classes.mobileShareContainer}>
                  <Typography className={classes.mobileShareTitle}>Partager ce test</Typography>
                  <div className={classes.mobileShareActions}>
                    <TwitterShareButton url={testUrl} title={dataMax?.title}>
                      <TwitterIcon
                        style={{
                          color: '#001A8C',
                          fontSize: 16,
                          height: 16,
                          width: 16,
                          margin: 0,
                          display: 'block',
                          cursor: 'pointer',
                        }}
                      />
                    </TwitterShareButton>

                    <FacebookShareButton url={testUrl} title={dataMax?.title}>
                      <FacebookIcon
                        style={{
                          color: '#001A8C',
                          fontSize: 16,
                          height: 16,
                          width: 16,
                          margin: 0,
                          display: 'block',
                          cursor: 'pointer',
                        }}
                      />
                    </FacebookShareButton>

                    <LinkedinShareButton url={testUrl} title={dataMax?.title}>
                      <LinkedInIcon
                        style={{
                          color: '#001A8C',
                          fontSize: 16,
                          height: 16,
                          width: 16,
                          margin: 0,
                          display: 'block',
                          cursor: 'pointer',
                        }}
                      />
                    </LinkedinShareButton>
                    <Button
                      variant="contained"
                      style={{
                        background: '#001A8C',
                        color: '#fff',
                        borderRadius: 20,
                        padding: '6px 18px',
                        fontWeight: 500,
                        fontSize: 12,
                        textTransform: 'none',
                        boxShadow: 'none',
                      }}
                      className={classes.copyLinkButton}
                      endIcon={
                        <FileCopyOutlinedIcon
                          style={{
                            color: '#fff',
                            fontSize: 16,
                          }}
                        />
                      }
                      onClick={() => {
                        navigator.clipboard.writeText(testUrl);
                      }}>
                      Copier le lien
                    </Button>
                  </div>
                  {besoinAideRow}
                </div>
              )}
            </>
          )}

          {/* Section des tests recommandés */}
          <RecommendedTestsSection
            recommendedTests={test?.attributes?.recommendedTests || []}
            completedTestIds={completedTestIds}
            currentUserId={user.id}
          />
        </div>
      )}

      {/* Modal de feedback */}
      <FeedbackModal
        open={showFeedbackModal}
        onClose={handleFeedbackClose}
        onSubmit={handleFeedbackSubmit}
        isSubmitting={isSubmitting}
        error={error || undefined}
      />
      <HelpModal
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        defaultEmail={user?.email}
        defaultName={user?.lastname || user?.lastName || ''}
        defaultFirstName={user?.firstname || user?.firstName || ''}
      />
    </Layout>
  );
};

export default withWidth()(Resultats);
